import { Injectable } from '@angular/core';

import { RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthSelectors, SetReturnUrl } from '@app/store';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private store: Store) {}

  protected isAuthenticated$: Observable<boolean> = this.store.select(
    AuthSelectors.isAuthenticated,
  );

  canActivate(routerStateSnapshot: RouterStateSnapshot): Observable<boolean> {
    return this.isAuthenticated$.pipe(
      map((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          this.store.dispatch(
            new SetReturnUrl(
              this.transformToUrl(
                routerStateSnapshot.url as unknown as UrlSegment[],
              ),
            ),
          );
          // this.store.dispatch(new Navigate(['/access-denied']));
          this.store.dispatch(new Navigate(['/auth']));
          return false;
        }

        return true;
      }),
    );
  }

  protected transformToUrl(urlSegments: UrlSegment[]): string {
    return urlSegments
      .map((urlSegment: UrlSegment) => {
        return '/' + urlSegment.path;
      })
      .join('');
  }
}
